<template>
  <svg
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8346 4.16797L4.16797 15.8346M4.16797 4.16797L15.8346 15.8346"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.25"
    />
  </svg>
</template>
